<template>
  <base-hm-input :id="id"
                 :class="[
                   $attrs['class'],
                   { 'has-inline-icon-left': hasSlot('icon-inline-left') },
                   { 'has-inline-icon-right': hasSlot('icon-inline-right') },
                 ]"
                 :label="label"
                 :help="help"
                 :has-focus="hasFocus"
                 :is-empty="isValueEmpty"
                 :name="name"
                 :cols="cols"
                 :hidden="hidden"
                 :style="iconCountStyleVariables"
                 :disabled="disabled">
    <input v-mask="mask"
           v-if="disabled"
           :id="`${id}-input`"
           v-model.trim.lazy="internalValue"
           :data-vv-as="label"
           :data-vv-name="name"
           :name="name"
           :disabled="disabled"
           :autocomplete="autocomplete"
           :maxlength="maxlength"
           :type="type"
           :readonly="readonly"
           class="hm-input__input"
           @paste="onPaste"
           @focus="onFocus"
           @blur="onBlur">
    <input v-mask="mask"
           v-else
           :id="`${id}-input`"
           v-model.trim="internalValue"
           :data-vv-as="label"
           :data-vv-name="name"
           :name="name"
           :disabled="disabled"
           :autocomplete="autocomplete"
           :maxlength="maxlength"
           :type="type"
           :readonly="readonly"
           class="hm-input__input"
           @paste="onPaste"
           @focus="onFocus"
           @blur="onBlur">
    <div :class="[{ 'hm-input__icon--input-hover': hover }, { 'hm-input__icon--input-focus': hasFocus}]" class="hm-input__icon__wrapper hm-input__icon__wrapper--left">
      <slot :hover="hover" :focus="hasFocus" name="icon-inline-left"></slot>
    </div>
    <div :class="[{ 'hm-input__icon--input-hover': hover }, { 'hm-input__icon--input-focus': hasFocus}]" class="hm-input__icon__wrapper hm-input__icon__wrapper--right">
      <slot :hover="hover" :focus="hasFocus" name="icon-inline-right"></slot>
    </div>
  </base-hm-input>
</template>

<script>

import HmInput from './HmInput';

export default {
  name: 'HmInputMask',
  extends: HmInput,

  props: {
    mask: {
      type: String,
      required: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmInputMask.vue